const reasons = [
  {
    icon: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </svg>
    ),
    title: "Personalized Service",
    description:
      "One-on-one access with a licensed agent to formulate an insurance plan that meets your exact needs.",
  },
  {
    icon: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <line x1="12" y1="1" x2="12" y2="23" />
        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
      </svg>
    ),
    title: "Competitive Rates",
    description:
      "Affordable rates with flexible payment options. Get correct quality at a price you can absolutely afford.",
  },
  {
    icon: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      </svg>
    ),
    title: "Quality and Care",
    description:
      "We treat clients like family. Our promise: the right coverage at an unbeatable price for ultimate peace of mind.",
  },
];

export default function WhyChoosePaladinSection() {
  return (
    <section
      className="w-full py-20 px-6 relative overflow-hidden"
      style={{ backgroundColor: "#012E72" }}
    >
      {/* Grid texture */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage:
            "repeating-linear-gradient(90deg, rgba(255,255,255,0.03) 0px, rgba(255,255,255,0.03) 1px, transparent 1px, transparent 80px), repeating-linear-gradient(0deg, rgba(255,255,255,0.03) 0px, rgba(255,255,255,0.03) 1px, transparent 1px, transparent 80px)",
        }}
      />

      {/* Radial glow */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse 70% 60% at 50% 40%, rgba(0,45,181,0.45) 0%, transparent 100%)",
        }}
      />

      <div className="max-w-5xl mx-auto relative">

        {/* Header */}
        <div className="flex flex-col items-center text-center gap-4 mb-14">
          <div className="flex items-center gap-3">
            <div className="w-1 h-4 bg-white-pure rounded-full opacity-30" />
            <span
              className="font-cinzel text-white-pure uppercase tracking-widest"
              style={{ fontSize: "11px", letterSpacing: "0.2em", opacity: 0.6 }}
            >
              Why Choose Us
            </span>
            <div className="w-1 h-4 bg-white-pure rounded-full opacity-30" />
          </div>

          <h2
            className="font-cinzel font-bold text-white-pure uppercase"
            style={{
              fontSize: "clamp(22px, 3.5vw, 38px)",
              letterSpacing: "0.06em",
              lineHeight: "1.15",
            }}
          >
            Why Choose Paladin?
          </h2>

          <p
            className="font-constantia text-white-pure max-w-lg leading-relaxed"
            style={{ fontSize: "16px", opacity: 0.65 }}
          >
            Trusted guidance, fair pricing, and personalized protection designed
            around your needs.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
          {reasons.map(({ icon, title, description }) => (
            <div
              key={title}
              className="rounded-2xl flex flex-col gap-5 p-8 transition-all duration-200 hover:translate-y-[-2px]"
              style={{
                backgroundColor: "rgba(255,255,255,0.06)",
                border: "1px solid rgba(255,255,255,0.1)",
              }}
            >
              {/* Icon circle */}
              <div
                className="w-12 h-12 rounded-full flex items-center justify-center text-white-pure flex-shrink-0"
                style={{ backgroundColor: "rgba(255,255,255,0.12)" }}
              >
                {icon}
              </div>

              <h3
                className="font-cinzel font-bold text-white-pure"
                style={{ fontSize: "15px", letterSpacing: "0.04em" }}
              >
                {title}
              </h3>

              <div className="h-px w-8 bg-white-pure opacity-20" />

              <p
                className="font-constantia text-white-pure leading-relaxed"
                style={{ fontSize: "15px", opacity: 0.65 }}
              >
                {description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}